//#region Util Imports

import * as _ from 'underscore'

//#endregion

import { Enums } from '../../../models/common/enums'
import { IOpObject, IReferenceType } from '../../../models/util/interfaces'
import { OpLocation } from '../../../models/core/op-location'

import { CreateEditController, CreateEditScope } from '../../common/common.create-edit.controller'
import { CreateEditInitParams, BulkEditInitParams } from '../../common/create-edit-popup/create-edit-popup.controller'

import { IUserSession } from '../../../helpers/user-session'
import { LocalizationHelper } from '../../../helpers/localization-helper'
import { ConvertHelper, ToastHelper } from '../../../helpers'

import { DepositoryHelper } from '../depositories.helper'
import { DepositoryService } from '../../../services/depository'

interface DepositoryCreateEditScope extends CreateEditScope {
    isCreateEditAdditionalFields: boolean
}

export class DepositoryCreateEditController extends CreateEditController {

    // Members

    private referenceValue: OpLocation

    // Members End

    //#region Ctor

    public constructor(
        private $scope: DepositoryCreateEditScope,
        $q: ng.IQService,
        $timeout: ng.ITimeoutService,
        protected userSession: IUserSession,
        private moduleName: Enums.SimaxModuleName
    ) {
        super(DepositoryService.REFERENCE_TYPE, moduleName, $scope, $timeout, $q)

        this.$scope.isCreateEditAdditionalFields = true
    }

    //#endregion

    //#region CreateEditController Overrides

    protected onInitialize(createEditInitParams: CreateEditInitParams): void {
        this.referenceValue = createEditInitParams ? <OpLocation>createEditInitParams.referenceObject : null

        if (this.referenceValue && this.referenceValue.idObject > 0) {
            this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__EDITING, this.moduleName)
        } else {
            this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__ADDING, this.moduleName)

            if (createEditInitParams.customDataSources != null) {
                const locTypes: IReferenceType[] = createEditInitParams.customDataSources.tryGetValue(Enums.ReferenceType.IdLocationType)

                if (_.size(locTypes) === 1) {
                    if (createEditInitParams.customDataSourcesDefaultValues == null) {
                        createEditInitParams.customDataSourcesDefaultValues = {}
                    }

                    createEditInitParams.customDataSourcesDefaultValues[Enums.DataType.HELPER_ID_LOCATION_TYPE] = locTypes[0].getReferenceKey()
                }
            }           
        }

        super.openCreateEdit(createEditInitParams);
    }

    protected onBulkInitialize(bulkEditInitParams: BulkEditInitParams): void {
        this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__MASS_EDITING, this.moduleName)
        this.$scope.gridData = bulkEditInitParams;

        super.openBulkCreateEdit(bulkEditInitParams);
    }

    protected onSaving(objectToSave: IOpObject): JQueryPromise<IOpObject> {
        return DepositoryHelper
            .saveDepository(this.userSession.getDataProvider(), OpLocation.fromIOpObject(objectToSave))
            .then((savedObject: OpLocation) => {
                super.complete(savedObject);

                ToastHelper.showSuccess(LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__SAVED, this.moduleName))

                return savedObject;
            })
            .fail((error: any) => {
                super.completeWithError(error);

                ToastHelper.showError(ConvertHelper.getRequestErrorMessage(error) || LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExceptionOccuredPleaseContactAnAdministrator))

                return $.Deferred().reject(error);
            })
    }

    protected onBulkSaving(objectToSave: IOpObject): JQueryPromise<IOpObject> {
        return DepositoryHelper.saveDepository(this.userSession.getDataProvider(), OpLocation.fromIOpObject(objectToSave))
    }

    //#endregion
}